const toDate = (value) => (value instanceof Date ? new Date(value) : new Date(value));

export const startOfDay = (value) => {
  const date = toDate(value);
  date.setHours(0, 0, 0, 0);
  return date;
};

export const getMonthStart = (value) => {
  const date = toDate(value);
  return new Date(date.getFullYear(), date.getMonth(), 1);
};

export const getMonthEnd = (value) => {
  const date = toDate(value);
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

// A month is "closed" once its last calendar day has arrived (today counts).
export const isMonthClosed = (value, today = new Date()) =>
  startOfDay(getMonthEnd(value)).getTime() <= startOfDay(today).getTime();

export const getBmvLabelDate = (reportDate) => getMonthStart(reportDate);

// Closed month  -> month end (5/15 and 5/31 both resolve to 5/31)
// Open month    -> the selected date itself (7/14 stays 7/14)
export const getEmvLabelDate = (reportDate, today = new Date()) =>
  isMonthClosed(reportDate, today) ? getMonthEnd(reportDate) : startOfDay(reportDate);

export const formatPeriodLabel = (value) => {
  const date = toDate(value);
  return `${date.getMonth() + 1}/${date.getDate()}`;
};

export const clampToToday = (value, today = new Date()) => {
  const selected = startOfDay(value);
  const max = startOfDay(today);
  return selected.getTime() > max.getTime() ? max : selected;
};

export const toDateInputValue = (value) => {
  const date = startOfDay(value);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};